module.exports = __webpack_public_path__ + "img/广州办公室.91c05b8f.jpg";